import { useDaily } from '@daily-co/daily-react'
import { useEffect } from 'react'
import { isDeployedToProduction } from 'utils/isDeployedToProduction'

const events = [
  'loading',
  'load-attempt-failed',
  'loaded',
  'started-camera',
  'camera-error',
  'joining-meeting',
  'joined-meeting',
  'left-meeting',
  'call-instance-destroyed',
  'participant-joined',
  'participant-updated',
  'participant-left',
  'participant-counts-updated',
  'track-started',
  'track-stopped',
  'recording-started',
  'recording-stopped',
  'recording-stats',
  'recording-error',
  'recording-upload-completed',
  'recording-data',
  'transcription-started',
  'transcription-stopped',
  'transcription-error',
  'app-message',
  'transcription-message',
  'local-screen-share-started',
  'local-screen-share-stopped',
  'local-screen-share-canceled',
  'active-speaker-change',
  'active-speaker-mode-change',
  'network-quality-change',
  'network-connection',
  'test-completed',
  'cpu-load-change',
  'face-counts-updated',
  'fullscreen',
  'exited-fullscreen',
  'error',
  'nonfatal-error',
  'click',
  'mousedown',
  'mouseup',
  'mouseover',
  'mousemove',
  'touchstart',
  'touchmove',
  'touchend',
  'live-streaming-started',
  'live-streaming-updated',
  'live-streaming-stopped',
  'live-streaming-error',
  'lang-updated',
  'remote-media-player-started',
  'remote-media-player-stopped',
  'remote-media-player-updated',
  'access-state-updated',
  'meeting-session-updated',
  'meeting-session-summary-updated',
  'meeting-session-state-updated',
  'waiting-participant-added',
  'waiting-participant-updated',
  'waiting-participant-removed',
  'theme-updated',
  'available-devices-updated',
  'receive-settings-updated',
  'input-settings-updated',
  'send-settings-updated',
  'local-audio-level',
  'remote-participants-audio-level',
  'show-local-video-changed',
  'selected-devices-updated',
  'custom-button-click',
  'sidebar-view-changed',
  'pip-started',
  'pip-stopped',
  'dialin-connected',
  'dialin-ready',
  'dialin-error',
  'dialin-stopped',
  'dialin-warning',
  'dialout-connected',
  'dialout-answered',
  'dialout-error',
  'dialout-stopped',
  'dialout-warning',
] as const

type Input = { show?: boolean }

export function useDailyDevLogs({ show = false }: Input) {
  const callObject = useDaily()
  useEffect(() => {
    if (!callObject || isDeployedToProduction || !show) return
    const handlers = {}
    events.forEach((event) => {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      handlers[event] = (...args) => console.log(`[daily] ${event}`, ...args)
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      callObject.on(event, handlers[event])
    })
    return () => {
      events.forEach((event) => {
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        callObject.off(event, handlers[event])
      })
    }
  }, [callObject, show])
}
